import React from 'react';
import useGradesTableStore from '@/components/staffer/AssignmentsBasedGradesTable/store/useGradesTableStore';
import { teacher_assignment_student_grading_path } from '@/modules/routes';
import { IExerciseProgress } from './utils/ReadingAssignmentsTable.types';

interface IReadingStatusLinkProps extends React.HTMLProps<HTMLAnchorElement> {
  cellId?: string;
  progress?: IExerciseProgress;
  sectionTitle: string;
  studentName: string;
  studentId: number;
}

const getAriaLabel = (
  sectionTitle: string, studentName: string, progress: IExerciseProgress,
) => {
  const suffix = 'Click to navigate to results for student.';

  if (progress) {
    return `${sectionTitle} is ${progress.status === 'in_progress' ? 'in progress' : 'completed'} for ${studentName}. ${suffix}`;
  }

  return `${studentName} hasn't started ${sectionTitle}. ${suffix}`;
};

const ReadingStatusLink = ({
  cellId,
  children,
  progress,
  sectionTitle,
  studentId,
  studentName,
  ...rest
}: IReadingStatusLinkProps) => {
  const assignment = useGradesTableStore(state => state.assignment);
  const navigationParams = useGradesTableStore(state => state.navigationParams());

  const gradingPageUrl = teacher_assignment_student_grading_path(assignment.id,
    studentId,
    { ...navigationParams, ...(cellId ? { defaultExpanded: cellId } : {}) });

  return (
    <a
      aria-label={getAriaLabel(sectionTitle, studentName, progress)}
      className="tw-h-full tw-w-full tw-flex tw-justify-center tw-items-center tw-gap-4"
      href={gradingPageUrl}
      rel="noopener noreferrer"
      target="_blank"
      {...rest}
    >
      {children}
    </a>
  );
};

export default ReadingStatusLink;
